import axios from 'axios'
import {Auth_Proto,Auth_Domain,Auth_Port} from '../../Component/consts'

class EquityService{
    
   

   getSubHeads(tenantId){
        return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/getsubheads/${tenantId}`)
      }

  getBusinesstype(){
        return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/businesstypes`)
      }

  getPartners(tenantId){
        return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/partners/${tenantId}`)
      }

  saveEquity(payload){
      return axios.post(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/sharecapital`, payload)
      }

    getAllocatList(tenantId){
      return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/allocatlist/${tenantId}`)
    }

    deleteAllocat(id){
          return axios.put(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/softdelete/${id}`)
        }

    getInitialCap(tenantId){
        return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/initialcap/${tenantId}`)
    }

    updateEntry(payload){
      // use PUT to update existing allocation/entry
      return axios.put(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/updateentry`, payload)
    }

    getPurposes(){
      return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/purposes`)
    }

  


}

export default new EquityService();
